import * as React from "react";
const SvgFiRrFaceWorried = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-worried_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10M7 11.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 11.5m8.5 1.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 15.5 13M6.782 8.624a1 1 0 0 1-1.405.158 1 1 0 0 1-.159-1.405c.91-1.141 2.307-2.064 3.559-2.351a1 1 0 0 1 .447 1.949c-.812.187-1.817.864-2.442 1.649m12-1.247a1 1 0 0 1-1.564 1.247c-.625-.785-1.629-1.462-2.441-1.649a1 1 0 0 1 .447-1.949c1.252.287 2.648 1.21 3.559 2.351zm-1.876 10.39c.395.597-.157 1.365-.877 1.214-.93-.195-1.998-.98-4.03-.981-2.032 0-3.023.785-3.953.981-.72.151-1.272-.617-.876-1.214C8.019 16.485 9.542 15 12.041 15s4.016 1.484 4.865 2.767"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-worried_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceWorried;
